<div class="purchase-order-shipments">
  <lum-purchase-order-shipments-filters></lum-purchase-order-shipments-filters>
  <div class="mt-4">
    <lum-purchase-order-shipments-table></lum-purchase-order-shipments-table>
  </div>
</div>
